var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center align-items-center pt-8"},[_c('h1',{staticClass:"mr-3 pr-3 align-top border-right inline-block align-content-center"},[_vm._v("404")]),_c('div',{staticClass:"inline-block align-middle"},[_c('h2',{staticClass:"font-weight-normal lead"},[_vm._v("Pagina niet gevonden.")])])])])
}]

export { render, staticRenderFns }